module.exports = __webpack_public_path__ + "static/Company_logo_1-4b690c28f028bb107033dc604c348198.png";